const uriConstants = {
    CASTOKENURI: `/rest/api/map/cas/token?orgId=`
}

export default uriConstants;